module.exports = __webpack_public_path__ + "3c374a48ea735ec843951fd6928a5d24.png";